import LogRocket from 'logrocket';

LogRocket.init('lbggis/clientbook');
